import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useGetClaimTypesQuery } from "AppQuries/claim/claim-type";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ImageUploder from "Components/UI/ImageUploder";
import MultiImageUploader from "Components/UI/MultiImageUploader";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import {
  useFormattedDepartmentOption,
  useFormattedEmpGroupOption,
  useFormattedEmployees,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const isStatusOption2 = [
  { id: 1, label: "Yes", value: 1 },
  { id: 0, label: "No", value: 0 },
];

const AnnouncementForm = () => {
  const userData = useSelector(loggedInUser);
  const {
    control,
    getValues,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);

  const groupOptions = useFormattedEmpGroupOption(userData?.companyCode);

  const announcementTypeOptions = [
    {
      label: "Employee",
      value: "1",
    },
    {
      label: "Department",
      value: "2",
    },
    {
      label: "Groups",
      value: "3",
    },
  ];

  return (
    <div className="form-row row">
      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="title"
          type="text"
          placeholder="Title "
          className={`form-control ${errors.title ? "is-invalid" : ""}`}
          label="Title"
          labelClassName="form-label"
          required={true}
          requiredMessage="title is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="message"
          type="text"
          placeholder="Message"
          className={`form-control ${errors.message ? "is-invalid" : ""}`}
          label="Message"
          labelClassName="form-label"
          required={true}
          requiredMessage="Message is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="type"
          type="commonSelect"
          className={`form-control select ${errors.type ? "is-invalid" : ""}`}
          label="Announcement Type"
          optionData={announcementTypeOptions}
          required
          requiredMessage="type is required"
          value={watch("type")}
          onSelect={(e) => {
            setValue("code", "");
            setValue("type", e);
            trigger("code");
            trigger("type");
          }}
        />
      </div>

      {/* <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="code"
          type="commonSelect"
          className={`form-control select ${errors.code ? "is-invalid" : ""}`}
          label="Announced To"
          optionData={
            watch("type") === "1"
              ? employeeOptions?.map((dept) => ({
                  label: dept.label,
                  value: dept.value.toString(),
                }))
              : watch("type") === "2"
              ? departmentOptions?.map((dept) => ({
                  label: dept.label,
                  value: dept.value.toString(),
                }))
              : watch("type") === "3"
              ? groupOptions?.map((dept) => ({
                  label: dept.label,
                  value: dept.value.toString(),
                }))
              : []
          }
          required
          requiredMessage="type is required"
          allowClear
          //   value={watch("code")} // <-- UPDATED
          onChange={(e) => {
            setValue("code", e);
            trigger("code");
          }}
        />
      </div> */}

      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name={`code`}
          type="commonSelect"
          placeholder="E"
          className={`form-control ${errors?.code ? "is-invalid" : ""}`}
          optionData={
            watch("type") === "1"
              ? employeeOptions?.map((emp) => ({
                  label: emp.label,
                  value: emp.value.toString(),
                }))
              : watch("type") === "2"
              ? departmentOptions?.map((emp) => ({
                  label: emp.label,
                  value: emp.value.toString(),
                }))
              : watch("type") === "3"
              ? groupOptions?.map((emp) => ({
                  label: emp.label,
                  value: emp.value.toString(),
                }))
              : []
          }
          onChange={(selectedOptions) => {
            setValue(
              "code",
              Array.isArray(selectedOptions)
                ? selectedOptions.map((option) => option)
                : []
            );
          }}
          value={watch("code")?.length ? watch("code") : []}
          mode="multiple"
          label="Announced To"
          labelClassName="form-label"
          required={false}
          requiredMessage="Announced To is required"
          allowClear
          showSearch
          onClear={() => {
            setValue("code", []);
            trigger("code");
          }}
          style={{ width: "100%", height: "auto" }}
        />
      </div>

      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="startDate"
          type="date"
          placeholder="Start Date"
          className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
          label="Start Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="Start date is required"
          defaultValue=""
          dateFormat="YYYY-MM-DD"
        />
      </div>

      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="endDate"
          type="date"
          placeholder="End Date"
          className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
          label="End Date"
          labelClassName="form-label"
          required={true}
          requiredMessage="to date is required"
          defaultValue=""
          dateFormat="YYYY-MM-DD"
        />
      </div>

      {/* <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="remarks"
          type="text"
          placeholder="Remarks"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          label="Remarks"
          labelClassName="form-label"
          required={true}
          requiredMessage="Remarks is required"
          defaultValue=""
        />
      </div> */}

      <div className="col-md-6 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
      {/* <div className="col-md-6 col-sg-12 mb-3">
        <MultiImageUploader
          base64Values={watch(`claimAttachments`)?.map((a) => a.attachment)}
          setBase64Values={(value) => {
            addAttachments(value);
          }}
          removeAttachment={(attachmentIndex) =>
            removeAttachment(attachmentIndex)
          }
          id={`claim-attachment-uploader`}
        />
        
      </div> */}
    </div>
  );
};

export default React.memo(AnnouncementForm);
